import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { UpdateApiTokenRequestDto } from '../model';

const updateApiToken = async (
  args: UpdateApiTokenRequestDto,
  options?: RequestHandlerOptions
): Promise<void> => {
  const request = () =>
    apiClient.patch('/security/trading/webapi/token/update', args);
  const response = await handleRequest<void>(request, options);
  return response.data;
};

export { updateApiToken };
